module.exports = __webpack_public_path__ + "c179726eceb5d500fccc6a76701ba964.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio2/08_2MCA Cape Cod Chandelier.mp3
// module id = 790
// module chunks = 0